import { useMutation as e } from "@maat/store-hooks";
import { usersApi as t } from "@maat/api-main";
//#region src/users/admin/useStopImpersonationMutation.ts
var n = () => e({ mutationFn: () => t.stopImpersonation() });
//#endregion
export { n as useStopImpersonationMutation };
